export default {
  rankOrder: {
    ariaAddOption: 'Add {label} to ranked list',
    ariaMoveUp: 'Move up {label}',
    ariaMoveDown: 'Move down {label}',
    ariaRemoveOption: 'Remove {label} from ranked list',
  },
  coe: {
    ariaDisclaimer: 'Disclaimer',
    ariaQuestion: 'Question',
    ariaConversationHistory: 'Conversation history',
    ariaYourResponse: 'Your response {number}',
    ariaFollowUpQuestion: 'Follow-up question {number}',
    ariaResponseInput: 'Response input',
    ariaRespondingTo: 'Responding to',
    ariaSendResponse: 'Send response',
    ariaThinking: 'Thinking'
  },
  deviceView: {
    toolbar: 'Preview device',
    mobile: 'Mobile',
    tablet: 'Tablet',
    desktop: 'Desktop'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'Powered by QuestDIY',
    skipToContent: 'Skip to main content'
  },
  surveyProgress: 'Survey progress: {percentage}%',
  languageSwitcher: 'Select language',
}
